import Vue from 'vue'
import Vuex from 'vuex'
import Action from './actions-types'
import Mutation from './mutations-types'

Vue.use(Vuex)

const isMobileDevice = () => (
  navigator.maxTouchPoints
    ? !!(navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)) && (navigator.maxTouchPoints > 0)
    : !!(navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i))
)

export default new Vuex.Store({
  state: {
    lastScrollDirection: 'left',
    currentPreviewIndex: 1,
    isMenuVisible: false,
    scrollDirection: 'right',
    cursorState: 'default',
    orientation: window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape',
    didAlreadySeeIntroAnim: !!localStorage.getItem('did-already-see-intro-anim'),
    didAlreadyWatchIntroAnimInSection: !!sessionStorage.getItem('did-already-see-intro-anim-in-section'),
    didShowSelectorPresenter: !!localStorage.getItem('did-show-selector-presenter'),
    didSeeDragTooltip: !!localStorage.getItem('did-see-drag-tooltip'),
    previousVHeight: undefined,
    previousVWidth: undefined,
    vWidth: parseFloat(document.getElementsByTagName('html')[0].getBoundingClientRect().width.toFixed(2)),
    vHeight: document.documentElement.clientHeight,
    isMobile: isMobileDevice(),
    isContactModalOpen: false,
    previewBackgroundTexts: [
      'Esta Paisagem Sonora é composta por múltiplas gravações realizadas em várias cidades do estado do Ceará, Nordeste do Brasil, em 2015, quarto ano de uma longa estiagem.',
      'Site institucional para escritório de advogacia situado em São Paulo. Com foco em SEO e suporte a vários idiomas. Feito com Vue e GSAP para animações do logotipo.',
      'Logotipo para empresa de desenvolvimento de software e tecnologia da região do Cariri. O nome foi escolhido de modo que fosse fácil de pronunciar. A família Paguroidea foi escolhida como inspiração para o nome por conta da protocooperação entre o caranguejo ermitão e anêmonas do mar.',
      'A Dnare é um empresa que busca criar singularidade no dia a dia através de produtos de decorações únicos e com grande representatividade na vida das pessoas. A ideia principal acerca da marca é provocar sentimentos e lembranças toda vez que um produto Dnare for visto, seja em um simples gole de café ou até mesmo a chegada ao lar.',
      'Durante o brainstorm para concepção da marca, chegamos a dois traços principais que gostaríamos de transmitir com ela: amigabilidade e modularidade. Adicionalmente, optou-se por uma identidade para a marca que não remetesse diretamente a modernidade e tecnologia. Pensamos: por que não?',
      'Marca pessoal para professor de português com foco em concursos públicos. Símbolo com premissa principal de ser simples, de modo que qualquer um possa desenhar e ser inspirado em caligrafia, fazendo alusão a excelência.'
    ]
  },
  mutations: {
    [Mutation.SET_CURRENT_PREVIEW] (state, previewData) {
      state.currentPreviewIndex = previewData[0]
      state.lastScrollDirection = previewData[1]
    },
    [Mutation.GET_VIEWPORT_DIMENSIONS] (state) {
      state.orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape'
      state.previousVWidth = state.vWidth
      state.previousVHeight = state.vHeight
      state.vWidth = parseInt(document.getElementsByTagName('html')[0].getBoundingClientRect().width)
      state.vHeight = document.documentElement.clientHeight
    },
    [Mutation.TOGGLE_MENU] (state, menuVisibility) {
      state.isMenuVisible = menuVisibility
    },
    [Mutation.TOGGLE_DIRECTION] (state, direction) {
      state.scrollDirection = direction
    },
    [Mutation.CHANGE_CURSOR_STATE] (state, cursorState) {
      state.cursorState = cursorState
    },
    [Mutation.SET_DID_SEE_INTRO_ANIM] (state) {
      state.didAlreadySeeIntroAnim = true
      localStorage.setItem('did-already-see-intro-anim', 'true')
    },
    [Mutation.SET_DID_SHOW_SELECTOR_PRESENTER] (state) {
      state.didShowSelectorPresenter = true
      localStorage.setItem('did-show-selector-presenter', 'true')
    },
    [Mutation.SET_DID_WATCH_INTRO_ANIM_IN_SECTION] (state) {
      state.didAlreadyWatchIntroAnimInSection = true
      sessionStorage.setItem('did-already-see-intro-anim-in-section', 'true')
    },
    [Mutation.SET_TOGGLE_CONTACT_MODAL_OPEN] (state) {
      state.isContactModalOpen = !state.isContactModalOpen
    },
    [Mutation.SET_DID_SEE_DRAG_TOOLTIP] (state) {
      state.didSeeDragTooltip = true
      localStorage.setItem('did-see-drag-tooltip', 'true')
    }
  },
  actions: {
    [Action.SET_CURRENT_PREVIEW] ({ commit }, previewIndex) {
      commit(Mutation.SET_CURRENT_PREVIEW, previewIndex)
    },
    [Action.TOGGLE_MENU] ({ commit }, menuVisibility) {
      commit(Mutation.TOGGLE_MENU, menuVisibility)
    },
    [Action.TOGGLE_DIRECTION] ({ commit }, direction) {
      commit(Mutation.TOGGLE_DIRECTION, direction)
    },
    [Action.CHANGE_CURSOR_STATE] ({ commit }, cursorState) {
      commit(Mutation.CHANGE_CURSOR_STATE, cursorState)
    },
    [Action.GET_VIEWPORT_DIMENSIONS] ({ commit }) {
      commit(Mutation.GET_VIEWPORT_DIMENSIONS)
    },
    [Action.SET_DID_SEE_INTRO_ANIM] ({ commit }) {
      commit(Mutation.SET_DID_SEE_INTRO_ANIM)
    },
    [Action.SET_DID_SHOW_SELECTOR_PRESENTER] ({ commit }) {
      commit(Mutation.SET_DID_SHOW_SELECTOR_PRESENTER)
    },
    [Action.SET_DID_WATCH_INTRO_ANIM_IN_SECTION] ({ commit }) {
      commit(Mutation.SET_DID_WATCH_INTRO_ANIM_IN_SECTION)
    },
    [Action.SET_TOGGLE_CONTACT_MODAL_OPEN] ({ commit }) {
      commit(Mutation.SET_TOGGLE_CONTACT_MODAL_OPEN)
    },
    [Action.SET_DID_SEE_DRAG_TOOLTIP] ({ commit }) {
      commit(Mutation.SET_DID_SEE_DRAG_TOOLTIP)
    }
  }
})
